export default __webpack_public_path__ + "fff2a096db014f6239d4bb753655882d.woff2";